import { useRef, useEffect } from "react"

export function useFocus<T extends HTMLElement = HTMLElement>(dep: unknown) {
  const ref = useRef<T>(null)

  useEffect(() => {
    ref.current?.querySelector<HTMLElement>("fieldset, textarea")?.focus()
  }, [dep])

  return ref
}
